import React, { useState } from 'react';
import { postFirma } from '../services/api';
import '../styles/modal.css';

const FirmaModal = ({ isOpen, onClose, nombresDisponibles, onSuccess }) => {
  const [archivo, setArchivo] = useState(null);
  const [nombreMedico, setNombreMedico] = useState('');
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);

  if (!isOpen) return null;

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setArchivo(e.target.files[0]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!archivo) {
      setError('Debes seleccionar un archivo de imagen (PNG, JPG).');
      return;
    }
    if (!nombreMedico.trim()) {
      setError('Debes indicar el nombre del médico dueño de esta firma.');
      return;
    }

    try {
      setCargando(true);
      setError(null);

      const formData = new FormData();
      formData.append('file', archivo);
      formData.append('nombre_medico', nombreMedico.trim());

      await postFirma(formData);
      setArchivo(null);
      setNombreMedico('');
      onSuccess();
      onClose();
    } catch (err) {
      console.error('Error al subir firma:', err);
      setError(err.response?.data?.message || 'Error al subir la firma.');
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>

        <div className="modal-header">
          <h3>Subir Firma</h3>
          <button type="button" className="btn-close" onClick={onClose}>
            &times;
          </button>
        </div>
        <form onSubmit={handleSubmit} className="modal-body">
          {error && <div className="alert-error">{error}</div>}

          <div className="form-group">
            <label htmlFor="firma-file-input">Imagen de la firma escaneada (PNG, JPG):</label>
            <input
              id="firma-file-input"
              type="file"
              accept=".png,.jpg,.jpeg"
              onChange={handleFileChange}
              disabled={cargando}
            />
            {archivo && (
              <p className="file-name-selected">
                <i className="fas fa-file-image"></i> {archivo.name}
              </p>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="firma-medico-input">Nombre del Médico:</label>
            <input
              id="firma-medico-input"
              type="text"
              list="medicos-firma-datalist"
              className="form-control"
              placeholder="Selecciona uno existente o escribe uno nuevo"
              value={nombreMedico}
              onChange={(e) => setNombreMedico(e.target.value)}
              disabled={cargando}
            />
            <datalist id="medicos-firma-datalist">
              {(nombresDisponibles || []).map((nombre) => (
                <option key={nombre} value={nombre} />
              ))}
            </datalist>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn-secondary"
              onClick={onClose}
              disabled={cargando}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="btn-primary"
              disabled={cargando || !archivo || !nombreMedico.trim()}
            >
              {cargando ? 'Subiendo...' : 'Subir Firma'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FirmaModal;
